import React, {useContext} from 'react';
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {getLoginLogColumns} from "../../logs/columns/loginLogColumns";

const PlayerLoginLog = () => {
    const {playerData} = useContext(PlayerContext);
    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
        logType: 'login_log',
        userKey: playerData.userKey,
        isUnix: true
    };

    return (
        <LogTemplate
            columns={getLoginLogColumns}
            defaultSearchParams={defaultSearchParams}
            routerUrl={'/logs'}
            logName={'LoginLog'}
        />
    );
};

export default PlayerLoginLog;